import { z } from 'zod';

export const renameClipFilesResponseSchema = z.object({
  newBaseLocalPath: z.string().nullable(),
  newVerticalLocalPath: z.string().nullable(),
  newBasePath: z.string().nullable(),
  newVerticalPath: z.string().nullable(),
});

export type IRenameClipFilesResponse = z.infer<typeof renameClipFilesResponseSchema>;
